import React from 'react';

import { SpecialtySectionLayout } from '@/layouts/pages/business';
import { SpecialtyFeature } from '@/views/business';

import type { SpecialtyFeatureProps } from '@/views/business';

const specialtyFeatureProps: Partial<SpecialtyFeatureProps> = {
  textWrapProps: {
    w: { base: `80%`, md: `95%` },
  },
};

const SpecialtySection = () => (
  <SpecialtySectionLayout>
    <SpecialtyFeature
      title="SPECIALTY"
      description="커뮤니티에 실제 활동하는 유저를 섭외하여 진행하며 상황에 따라 육성 아이디로 진행이 가능합니다."
      iconUrl="/pages/business/viral/sections/specialty/icon_1.png"
      {...specialtyFeatureProps}
    />
    <SpecialtyFeature
      title="DETAIL"
      description="높은 캠페인 이해도를 바탕으로 디테일한 원고 작성을 통해 낮은 삭제율, 높은 KPI가 확보됩니다"
      iconUrl="/pages/business/viral/sections/specialty/icon_2.png"
      {...specialtyFeatureProps}
    />
    <SpecialtyFeature
      title="ACTIVITY"
      description="이벤트, 핫딜(제품판매), 브랜드 등 다양한 콘텐츠 영역에 걸쳐 진행가능합니다."
      iconUrl="/pages/business/viral/sections/specialty/icon_3.png"
      {...specialtyFeatureProps}
    />
  </SpecialtySectionLayout>
);

export default SpecialtySection;
